import React, { useState } from "react";
import cl from "classnames";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
// import Select from 'react-select/lib/Select'
// import InputComponent from 'react-select/lib/components/Input'
import classes from "./styles.module.scss";
import formatOptionLabel from "./formatOptionLabel";
import ClearButton from "./ClearButton";
import fixDropDownPositionMobile from "./fixMobileMenuPosition";
import useFixMobileMenuPositionOnScroll from "./useFixMobileMenuPositionOnScroll";

const Input =
  (extraProps = {}) =>
  (props) =>
    <components.Input {...props} {...extraProps} />;

const SelectField = React.forwardRef(
  (
    {
      value,
      onChange,
      containerClassName,
      className,
      options,
      clearButton,
      placeholder,
      inputProps = {},
      absolute = false,
      isSearchable = true,
      ...props
    },
    ref
  ) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    // console.log('value', value)

    useFixMobileMenuPositionOnScroll(menuIsOpen, absolute);
    return (
      <div className={cl(classes.SelectFieldContainer, containerClassName)}>
        <Select
          components={{ Input: Input(inputProps) }}
          value={
            menuIsOpen && isSearchable
              ? value
                ? { label: "Start typing..." }
                : undefined
              : value
          }
          placeholder={
            menuIsOpen && isSearchable ? "Start typing..." : placeholder
          }
          options={options}
          onChange={onChange}
          className={cl(classes.SelectField, className)}
          classNamePrefix="SelectField"
          formatOptionLabel={formatOptionLabel}
          menuPortalTarget={absolute || !document ? null : document.body}
          styles={{
            placeholder: (base) => ({
              ...base,
              color: "#ccc",
              fontSize: "1rem",
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            singleValue: (base, state) => ({
              ...base,
              color: state.selectProps.menuIsOpen ? "#ccc" : "#333",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected ? "#471dd1" : "#ffffff",
              color: state.isSelected ? "#ffffff" : "#545454",
            }),
          }}
          menuPosition={absolute ? "absolute" : "fixed"}
          menuPlacement={absolute ? undefined : "auto"}
          required
          ref={ref}
          onMenuOpen={() => {
            setMenuIsOpen(true);
            if (!absolute) fixDropDownPositionMobile();
          }}
          onMenuClose={() => {
            setMenuIsOpen(false);
          }}
          menuIsOpen={menuIsOpen}
          isSearchable={isSearchable}
          onInputChange={() => {
            if (!absolute) fixDropDownPositionMobile();
          }}
          {...props}
        />
        {!!value && clearButton && (
          <ClearButton onClick={() => onChange(null)} />
        )}
      </div>
    );
  }
);

SelectField.propTypes = {
  value: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  absolute: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.array.isRequired,
        PropTypes.string.isRequired,
      ]),
      label: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  clearButton: PropTypes.bool,
  isSearchable: PropTypes.bool,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
};

SelectField.defaultProps = {
  clearButton: false,
};

export default SelectField;
